<template>
  <v-container fluid>
    <v-dialog v-model="passwordDialog" width="350px" :key="passwordKey">
      <password-form v-on:close="passwordDialog=false" :userId="userId" class="px-10 pt-5"/>
    </v-dialog>
    <router-view v-on:resetPassword="openPassDialog"/>
  </v-container> 
</template>

<script>
export default {
  components:{
    PasswordForm: ()=> import('./components/PasswordForm.vue')
  },
  data() {
    return {
      passwordDialog: false,
      userId: '',
      passwordKey: 0
    }
  },
  
  methods:{
    openPassDialog(userId){
      this.userId= userId
      this.passwordKey ++
      this.passwordDialog = true
    },
    
  },
  computed:{
    isDownloader(){
      return this.$store.getters.getRole == "downloader"
    },
  } 
}
</script>

<style>
  .v-tab {
    font-size: 0.7em !important;
  } 
</style>